export class CustomField {
    id!: string;
    customFieldId!: string;
    fieldName!: string;
    value!: string;
    typeId!: string;
    template!: string;
}

export class AssetOwner {
    id!: string;
    name?: string;
    address?: string;
    zipCode?: string;
    city?: string;
    email?: string;
    mobile?: string;
    phone?: string;
}

export class AssetOverview {
    id!: string;
    externalId: string | null = null;
    modelName!: string;
    number: string | null = null;
    serialNumber: string | null = null;
    warrantyDate: string | null = null;
    year: string | null = null;
    address: string | null = null;
    zipCode: string | null = null;
    city: string | null = null;
    remark: string | null = null;
    service: boolean | null = null;
    nextService: string | null = null;
    installationContractor: IdValue = new IdValue();
    serviceOwner:  IdValue = new IdValue();
    owner: AssetOverviewOwner | null = null;
    category: IdValue = new IdValue();
    skill:  IdValue = new IdValue();
    labelId: string | null = null;
    createdAt: string | null = null;
}

export class IdValue {
    id: string | null = null;
    value: string | null = null;
}

export class AssetOverviewOwner {
    id: string | null = null;
    value: string | null = null;
    isCompany: boolean | null = null;
}

export class CreateAsset {
    modelName: string = '';
    serialNumber: string = '';
    warrantyDate: string = new Date().toISOString();
    address: string = '';
    zipCode: string = '';
    city: string = '';
    remark: string = '';
    installationContractor: string | null = null; // installers
    serviceOwner: string | null = null; // companyId
    ownerId: string | null = null; // customer
    customerOwnerId: string | null = null;
    companyOwnerId: string | null = null; 
    companyOwner: boolean = false;
    categoryId: string | null = null;
    skillId: string | null = null;
    labelId: string | null = null; // qr code 'https://asset.jublo.com/' + GUID
    propertyId: string | null = null;
    propertyLeaseId: string | null = null;
}

export class AssetById {
    id!: string;
    modelName?: string;
    serialNumber?: string;
    warrantyDate?: string;
    address ?: string;
    zipCode ?: string;
    city ?: string;
    remark ?: string;
    installationContractor ?: IdValue;
    serviceOwner ?: IdValue;
    owner ?: AssetServiceOwner;
    latitude?: number | null = null;
    longitude?: number | null = null;
    category ?: IdValue;
    skill ?: IdValue;
    labelId ?: string;
    createdAt ?: string;
    customFields?: AssetCustomField[];
    contactName?: string;
    contactEmail?: string;
    contactPhone?: string;
    image?:string;
    files?: string[];
    url?: string;
    year?: string;
    property?: AssetProperty;
    propertyLease?: AssetPropertyLease;
}

export class AssetProperty {
    id:string | null = null;
    propertyNumber:string = '';
    name:string = '';
    address:string = '';
    zipCode:string = '';
    city:string = '';
}

class AssetPropertyLease {
    id: string | null = null;
    propertyLeaseNumber!: string;
    address?: string;
    zipCode?: string;
    city?: string;
}

export class UpdateAsset {
    modelName!: string;
    serialNumber?: string;
    warrantyDate: string | null = null;
    year?: string;
    address?: string;
    zipCode?: string;
    city?: string;
    remark?: string;
    customerOwnerId: string | null = null;
    companyOwnerId: string | null = null;
    installationContractor: string | null = null;
    labelId?: string;
    serviceOwner: string | null = null;
    categoryId: string | null = null;
    skillId:string | null = null;
    customerFields?: UpdateCustomField[];
    contactName?: string;
    contactEmail?: string;
    contactPhone?: string;
}

export interface UpdateCustomField {
    name: string;
    value: string;
    typeId: string;
}

export class QROptions {
    width!: number;
    height!: number;
    data?: string;
    image?: string;
    margin?: number;
    dotsOptions: QrDotOptions = new QrDotOptions();
    backgroundOptions: QrBackgroundOptions = new QrBackgroundOptions();
    imageOptions: QrImageOptions = new QrImageOptions();
  }

  class QrDotOptions {
      color: string = '#1f539f';
      type: string = 'rounded';
  }

  class QrBackgroundOptions {
      color: string = '#ffffff';
  }

  class QrImageOptions {
      crossOrigin: string = 'anonymous';
      imageSize: number = .5;
      margin: number = 2;
  }

  export class AssetServiceOwner {
     id!:string;
     name?: string;
     address?: string;
     zipCode?: string;
     city?: string;
     email?: string;
     mobile?: string;
     phone?: string;
  }

  export class AssetCustomField {
    id!: string;
    customFieldId!: string;
    value!: string
    fieldName!: string;
    typeId!: string;
    template: string | string[] | null = null;
  }

export class AssetCases {
      caseNumber!: string;
      createdAt!: string;
      description!: string;
      id!: string;
  }